import React, { ErrorInfo, ReactNode } from 'react';
import ErrorBoundaryUI from './ErrorBoundaryUI';
import { HOME_PAGE } from '../../routes/routeConstants';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    // Check if the error is a ChunkLoadError
    if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
      console.warn("ChunkLoadError detected. Reloading the page...");
      window.location.reload(); // Reload the page to fetch the latest chunks
    }
  }

  getRefresh = () => {
    window.location.pathname = HOME_PAGE;
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI for the error
      return <ErrorBoundaryUI refreshFunc={this.getRefresh} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;